import { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ToggleButton from "react-bootstrap/ToggleButton";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  ErrorImg,
  base_url,
  logout,
  postHeader,
  s3_img_url,
} from "../../../Helper/request";
import axios from "axios";
import {
  addOffset,
  detailSlug,
  page,
  productcount,
  productlistdata,
  promostionCount,
  totalcount,
} from "../../../Reducer/productReducer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { wishlistlength } from "../../../Reducer/wishlistReducer";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import { isSpecialClicked } from "../../../Reducer/homeReducer";

const OfferListComp = ({ filtercall }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [screenWidth, setScreenWidth] = useState(window.screen.width);

  const faqMetaText = useSelector(
    (state) => state?.persistedReducer?.meta?.faqMeta
  );

  const categoryName = useSelector(
    (state) => state?.persistedReducer?.product?.categorydetails?.title
  );

  const promotionsItem = useSelector(
    (state) => state?.persistedReducer?.product?.promotionProducts
  );

  const promotionCountData = useSelector(
    (state) => state?.persistedReducer?.product?.promostionCount
  );

  const Offset = useSelector(
    (state) => state?.persistedReducer?.product?.addOffset
  );

  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    resizeScreen();

    window.addEventListener("resize", resizeScreen);

    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  }, []);

  useEffect(() => {
    if (filtercall) {
      setLoader(false);
    }
  }, [filtercall]);
  const addedfilter = useSelector(
    (state) => state.persistedReducer.product.addedfilter
  );
  const quickshipvalue = useSelector(
    (state) => state.persistedReducer.product.quickshipvalue
  );
  const isSpecial = useSelector(
    (state) => state.persistedReducer.home.isSpecialClicked
  );
  
  const userdata = useSelector((state) => state.persistedReducer.home.user);
  const prodList = useSelector(
    (state) => state.persistedReducer.product.productlist
  );

  const session_id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );
  const sortbyvalue = useSelector(
    (state) => state.persistedReducer.product.sortbyvalue
  );
  const { category, search, filterslug } = useParams();
  const product = useSelector((state) => state.persistedReducer.product);
  const [loader, setLoader] = useState(true);
  const [proIndex, setProIndex] = useState("");
  useEffect(() => {
    if (filtercall) {
      dispatch(productlistdata([]));
      dispatch(productcount(0));
      dispatch(page(1));
    }
  }, [addedfilter, quickshipvalue, sortbyvalue, category]);
  const controller = new AbortController();

  useEffect(() => {
    if (filtercall) {
      if (product?.pagecount == 1 || category != product?.listcategory ) {
        dispatch(productlistdata([]));
        dispatch(productcount(0));
        productlistapi();
      }
    }
    return () => {
      controller.abort();
    };
  }, [
    // filtercall,
    category,
    addedfilter,
    quickshipvalue,
    sortbyvalue,
    // product?.pagecount,
    search,
  ]);

  useEffect(() => {
    if (filtercall) {
      if (product?.pagecount != 1) {
        // alert("hello");
        productlistapi();
      }
    }
    return () => {
      controller.abort();
    };
    
  }, [product?.pagecount]);
  useEffect(() => {
    if (filtercall) {
      if (isSpecial) {
        // alert("hello");
        productlistapi();
      }
    }
    return () => {
      controller.abort();
    };
    
  }, [filtercall]);

  useEffect(() => {
    if (filtercall) {
      if (category != product?.listcategory) {
        dispatch(productlistdata([]));
        dispatch(productcount(0));
        // dispatch(page(1));
      } else {
        if (product?.pagecount !== 1) {
          productlistapi();
        }
      }
    }
    // productlistapi();
  }, [addedfilter, quickshipvalue, sortbyvalue, category, search]);
 
  const loadMoreHandle = (event) => {
    event.preventDefault()
    if (promotionCountData) {
      dispatch(addOffset(Offset + promotionCountData));
    } else {
      dispatch(addOffset(Offset + 40));
    }
    if (product?.productlist?.length == product?.pagecount * 40) {
      // filter add data by page number
      const val1 = promotionsItem?.filter(
        (data, i) =>
          Number(data?.page_number) == Number(product?.pagecount + 1) &&
          data?.page_number
      );
      if (val1?.length) {
        Number(val1[0]?.page_number) == Number(product?.pagecount + 1) &&
          dispatch(promostionCount(40 - val1[0]?.count));
      } else {
        dispatch(promostionCount(40));
      }
      dispatch(page(product?.pagecount + 1));
    }
  };
  const productlistapi = () => {

    dispatch(isSpecialClicked(false))
    setLoader(true);
    const data = {
      sort_by: sortbyvalue,
      category: category,
      search_text: search,
      filterdata: addedfilter,
      limit: 40,
      offset: (product?.pagecount - 1) * 40,
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id: session_id,
      quick_ship: quickshipvalue,
      token: userdata?.token ? userdata?.token : "",
    };

    axios
      .post(base_url + "/product/offerProductList", data, {
        headers: postHeader,
        signal: controller.signal,
      })
      .then((res) => {
        setLoader(false);
        if (res.data.status == 1) {
          dispatch(productcount(res.data.data?.count));
          if (product?.pagecount == 1) {
            dispatch(productlistdata(res.data.data?.result));
          } else {
            
            dispatch(
              productlistdata([
                ...product?.productlist,
                ...res.data.data?.result,
              ])
            );
          }
          // if (product?.pagecount == 1) {
          //   dispatch(productlistdata(res.data.data?.result));
          //   kleviyoListTracking()
          // } else {
          //   dispatch(
          //     productlistdata([
          //       ...product?.productlist,
          //       ...res.data.data?.result,
          //     ]),
          //   );
          // }
          var count = (res.data.data?.count / 40).toFixed();
          if (count * 40 >= res.data.data?.count) {
            dispatch(totalcount(count));
          } else {
            dispatch(totalcount(Number(count) + 1));
          }
        } else if (res.data.status == 2) {
          logout();
        } else {
          dispatch(productlistdata([]));
          dispatch(productcount(0));
          dispatch(totalcount(0));
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const comninationapi = (group_id, shape, color, click_id) => {
    const data = {
      group_id,
      shape,
      color,
      click_id,
    };
    axios
      .post(base_url + "/product/filter_shape_color_productlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          var changedata = product?.productlist?.map((val) =>
            val?.group_id == data?.group_id
              ? Object.assign({}, val, res.data.data?.result[0])
              : val
          );
          var temp = Object.assign(
            [],
            product?.productlist?.result,
            changedata
          );
          dispatch(productlistdata(temp));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let settings_1 = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
  };

  const fetchMoreData = () => {
    setTimeout(() => {
      if (product?.productlist?.length == product?.pagecount * 40) {
        dispatch(page(product?.pagecount + 1));
      }
    }, 500);
  };
  // Klaviyo events product list Start
  function kleviyoListTracking(params) {
    var item = {
      Categories: category,
      URL: window.location.href,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "View Product Listing", item]);
    }
  }
  // Klaviyo events product list End

  //-----------------------***************************** klaviyo wishlist event start
  function klaviyo_Wishlist(val) {
    var item = {
      ProductName: val?.name,
      ProductID: val?.product_id,
      SKU: val?.sku,
      Categories: val?.category_name,
      ImageURL: val?.product_image[0]?.url,
      Page_URL: window.location.href,
      Price: val?.price,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Added to wishlist", item]);
    }
  }
  //----------------------------**************************** klaviyo wishlist event End

  //******Klaviyo events Remove From Wishlist....****** Start
  function kleviyoRemoveWishlist(val) {
    var item = {
      Wishlist_id: val?.cart_id,
      ProductID: val?.product_id,
      ProductName: val?.name,
      price: val?.product_image[0]?.url,
      Page_URL: window.location.href,
      Image_Url: val?.url,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Remove From Wishlist", item]);
    }
  }
  // ******Klaviyo events Remove From Wishlist..********* End
  const add_to_wishlist = async (group_id, product_id, index) => {
    const data = {
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      product_id,
      group_id,
      token: userdata?.token ? userdata?.token : "",
    };
    await axios
      .post(base_url + "/product/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then(async (res) => {
        if (res.data.status == 1) {
          dispatch(wishlistlength(res.data.data.count));
          const data1 = await product?.productlist?.map((obj, ind) =>
            index == ind
              ? Object.assign({}, obj, {
                  is_wishlist: res.data.data.wishlist_id,
                })
              : obj
          );
          dispatch(productlistdata(data1));
        } else if (res.data.status == 2) {
          logout();
        } else {
          dispatch(productcount(0));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {metaData?.title ? metaData?.title : "Wedding Day Diamonds"}
        </title>
        <meta name="description" content={metaData?.meta_description}></meta>
        <meta name="keywords" content={metaData?.keywords}></meta>
      </Helmet>
      <div className="products_list">
        {/* <InfiniteScroll
        style={{ overflow: 'hidden' }}
        dataLength={product?.productlist?.length / 4}
        next={fetchMoreData}
        hasMore={product?.totalcount > product?.pagecount}
        scrollableTarget="products_list"
        loader={ */}
        <Row>
          {loader && !product?.productlist?.length
            ? [...Array(4)].map((val, i) => (
                <Col lg={3} md={4} xs={6} className="mt-5" key={i}>
                  <div className="product_box text-center">
                    <div className="product_bg">
                      <Skeleton height={230} />
                      <div className="d-flex justify-content-center">
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                      </div>
                    </div>
                    <h2 className="pro_name">
                      <Skeleton count={2} height={25} variant="text" />
                    </h2>
                    <div className="d-flex justify-content-center my-2">
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                    </div>
                    <span className="">
                      {" "}
                      <Skeleton height={25} variant="text" />
                    </span>
                  </div>
                </Col>
              ))
            : product?.productlist?.map((val, index) => (
                <Col lg={3} md={4} xs={6}>
                  <div className="product_box text-center">
                    <div className="product_bg">
                      {val?.top_pick == "yes" ? (
                        val?.overlay_top_left?.length ? (
                          <span className="overlay-top-left-text topPick d-flex align-items-center">
                            {val?.offer_icon_image && (
                              <img
                                src={val?.offer_icon_image}
                                className="img-fluid iconData"
                                alt=""
                              />
                            )}
                            {val?.overlay_top_left}
                          </span>
                        ) : (
                          ""
                        )
                      ) : val?.overlay_top_left?.length ? (
                        <span className="overlay-top-left-text topGift d-flex align-items-center">
                          {val?.offer_icon_image && (
                            <img
                              src={val?.offer_icon_image}
                              className="img-fluid iconData"
                              alt=""
                            />
                          )}
                          {val?.overlay_top_left}
                        </span>
                      ) : (
                        ""
                      )}
                      <Link
                        onMouseOver={() => {
                          setProIndex(index + 1);
                        }}
                        onMouseLeave={() => setProIndex("")}
                        className="img-link"
                        to={
                          "/product-detail/" + val?.group_id + "/" + val?.slug
                        }
                      >
                        <img
                          className="Pro_img"
                          id={"img-" + index + 1}
                          onError={() => ErrorImg("img-" + index + 1)}
                          src={
                            val?.product_image?.length > 0 &&
                            proIndex == index + 1
                              ? val?.product_image?.[1]?.url
                              : val?.product_image?.[0]?.url
                          }
                        />
                      </Link>
                      <span className="shipping_icon">
                        <img src={s3_img_url + 'shipping.png'} alt="Shipping" />
                      </span>
                      <span className="add-to-wishlist">
                        {val.is_wishlist == 0 ? (
                          <img
                            src={s3_img_url + 'heart.svg'}
                            onClick={() => {
                              klaviyo_Wishlist(val);
                              add_to_wishlist(
                                val?.group_id,
                                val?.product_id,
                                index
                              );
                            }}
                            alt="wishlist"
                          />
                        ) : (
                          <img
                            onClick={() => {
                              add_to_wishlist(
                                val?.group_id,
                                val?.product_id,
                                index
                              );
                              kleviyoRemoveWishlist(val);
                            }}
                            src={s3_img_url + 'heart-fill.svg'}
                            alt="added wishlist"
                          />
                        )}
                      </span>
                      <ul className="pro_metal_color">
                        {val?.colors?.map((color) => (
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip {...props}>{color?.name}</Tooltip>
                            )}
                            placement="top"
                          >
                            <li
                              className={
                                val?.metalcolor == color.value ? "active" : ""
                              }
                            >
                              <span
                                onClick={() =>
                                  comninationapi(
                                    val?.group_id,
                                    val?.shape,
                                    color?.value,
                                    1
                                  )
                                }
                              >
                                {color?.icon?.length ? (
                                  <img src={color?.icon} alt={color?.name} />
                                ) : (
                                  <div className="metal_box_noimg">
                                    {String(
                                      color?.name?.split(" ").slice(0, 1)
                                    ).slice(0, 1)}
                                    {String(
                                      color?.name?.split(" ").slice(1, 2)
                                    ).slice(0, 1)}
                                  </div>
                                )}
                              </span>
                            </li>
                          </OverlayTrigger>
                        ))}
                      </ul>
                      {/* <span className="overlay-bottom-center-text">{val?.overlay_bottom}</span> */}
                    </div>
                    <Link
                      to={"/product-detail/" + val?.group_id + "/" + val?.slug}
                    >
                      <h3 className="pro_name">{val?.name}</h3>
                    </Link>
                    {val?.shapes?.length ? (
                      <Slider {...settings_1} className="product_box_shap">
                        {val?.shapes?.map((shape, idx) => (
                          <div>
                            <OverlayTrigger
                              overlay={(props) => (
                                <Tooltip {...props}>{shape.name}</Tooltip>
                              )}
                              placement="top"
                            >
                              <ToggleButton
                                key={idx}
                                // id={`shap-${idx}`}
                                type="radio"
                                variant={"outline-defult"}
                                className={
                                  val?.shape == shape.value ? "active" : ""
                                }
                                name="shap"
                                value={shape.value}
                              >
                                <img
                                  height={25}
                                  onClick={() =>
                                    comninationapi(
                                      val?.group_id,
                                      shape?.value,
                                      val?.metalcolor,
                                      2
                                    )
                                  }
                                  src={shape?.icon}
                                  alt={shape.value}
                                />
                              </ToggleButton>
                            </OverlayTrigger>
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <div style={{ marginBottom: "-10px" }}></div>
                    )}

                    <h4 className="pro_price">
                      {Number(val?.product_group_count) > 1 && <i>From </i>}
                      {val?.offer_price && val?.offer_price !== val?.price && (
                        <del style={{ marginRight: "5px" }} className="mr-2">
                          {val?.currency + val?.price}
                        </del>
                      )}
                      <span
                        className={
                          val?.offer_price && val?.offer_price !== val?.price
                            ? "salmonColor"
                            : ""
                        }
                      >
                        {val?.currency}
                        {val?.offer_price && val?.offer_price == val?.price
                          ? val?.price
                          : val?.offer_price}
                        {!val?.offer_price && val?.price}
                      </span>
                    </h4>
                  </div>
                </Col>
              ))}
        </Row>
        {/* </InfiniteScroll> */}
        <div className="text-center mb-5 mt-4">
          {loader && product?.pagecount !== 1 ? (
            <div className="d-flex justify-content-center">
              <button
                className="loadMore_Loader  d-flex align-items-center justify-content-center"
                disabled={true}
              >
                <Spinner style={{ width: "20px", height: "20px" }} />{" "}
                <span className="ml-2">Loading...</span>
              </button>
            </div>
          ) : (
            product?.productlist?.length == product?.pagecount * 40 && (
              <button type="button"
                className="loadMoreList transition"
                onClick={loadMoreHandle}
              >
                Load More
              </button>
            )
          )}
{/* {console.log(product?.productlist?.length,'product?.productlist?.length =====',product?.productlist?.length <= product?.pagecount * 40,product?.pagecount * 40)
        } */}
        </div>
       
      </div>
    </>
  );
};

export default OfferListComp;
